<template>
  <v-col cols="12" lg="6" v-if="headersLoaded">
    <div class="mb-5">
      <PendingInvoices :data="pendingInvoicesData" :headers="headersPendingInvoices" :isLoading="dataLoading"/>
    </div>
    <div>
      <PendingOffers :data="pendingOffersData" :headers="headersPendingOffers" :isLoading="dataLoading"/>
    </div>
  </v-col>
</template>

<script>
import {mapState} from 'vuex';
import PendingInvoices from "./PendingInvoices/PendingInvoices";
import PendingOffers from "./PendingOffers/PendingOffers";

export default {
  name: "LeftSection",
  components: {PendingOffers, PendingInvoices},
  computed: {
    ...mapState("getDashboardData", {
      headersLoaded: state => state.headersLoaded,
      dataLoading: state => state.dataLoading,

      pendingInvoicesData: state => state.pendingInvoicesData,
      headersPendingInvoices: state => state.headersPendingInvoices,

      pendingOffersData: state => state.pendingOffersData,
      headersPendingOffers: state => state.headersPendingOffers,
    })
  },
}
</script>

<style scoped>

</style>